import './CommonHero.css';


export default function CommonHero() {
    return (
        <header className="common-hero">
            <h1>Latest from the Auto World</h1>
            <p>Read expert blogs about Bikes, Cars, and the thrill of the road.</p>
        </header>
    );
}